/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Modal, Segment, Form, Input,
  Button, Divider, Dimmer, Loader, Icon,
  Header, Checkbox, Dropdown, Popup
} from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeRouteAction } from "actions/changeActiveItemActions";
import UpdateLoader from "components/login-config/configuration/UpdateLoader";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";
import sha256 from "js-sha256";
import Timezones from "utilities/Timezones";

const UtilsInstance = new Utils();

class GeneralConfiguration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      ntpAddr: "",
      isNtpActive: false,
      ntpCheckboxLabel: Strings.WLAN_ADAPTER_OFF,
      timezone: "",
      isNtpModalOpen: false,
      isDimmerActive: false,
      isNtpDimmerActive: false,
      isUpdateDimmerActive: false,
      updateStatus: Constants.NOT_UPDATING,
      ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED,
    };
    this.updateLoaderRef = React.createRef();
  }

  showDimmer = () => this.setState({ isDimmerActive: true });
  hideDimmer = () => this.setState({ isDimmerActive: false });

  showUpdateDimmer = () => this.setState({ isUpdateDimmerActive: true });
  hideUpdateDimmer = () => this.setState({ isUpdateDimmerActive: false });

  showNtpDimmer = () => this.setState({ isNtpDimmerActive: true });
  hideNtpDimmer = () => this.setState({ isNtpDimmerActive: false });

  showNtpModal = () => this.setState({ isNtpModalOpen: true });
  hideNtpModal = () => this.setState({ isNtpModalOpen: false });

  retrieveData = async () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "ntp", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        ntpAddr: data.ntpIp,
        isNtpActive: data.ntp,
        timezone: data.timezone,
        ntpCheckboxLabel: data.ntp ? Strings.WLAN_ADAPTER_ON : Strings.WLAN_ADAPTER_OFF
      }));
  }

  //Sends a .gpg file to the server to update the monitor software
  sendFile = () => {
    let input = document.getElementById("send-gpg-input");
    // If the file exists and doesn't contain ".gpg" in its name
    if (input.files[0] !== undefined && input.files[0] !== null) {
      if (input.files[0].name.indexOf(Constants.GPG_FILE_EXTENSION) === -1) {
        alert(Strings.GPG_ALERT_MESSAGE);
      }
      else {
        let data = new FormData();
        let reader = new FileReader();
        let sha256Checksum = "";

        reader.onload = (event) => {
          sha256Checksum = sha256(event.target.result);

          data.append("updateFile", input.files[0]);
          data.append("checkSum", sha256Checksum);

          this.showDimmer();

          fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "sendFile_POST", {
            method: "POST",
            body: data
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              this.handleUpdateCycles(Constants.FILE_UPDATE_TYPE);
            })
            .catch((error) => {
              if (error.response.status === 415) {
          alert(Strings.SEND_FILE_FAILURE + Strings.REASON + Strings.SEND_FILE_WRONG_FILENAME_PROTOCOL);
              }
              else if (error.response.status === 417) {
          alert(Strings.SEND_FILE_FAILURE + Strings.REASON + Strings.SEND_FILE_CORRUPTED_FILE);
              }
              else {
          alert(Strings.SEND_FILE_FAILURE + Strings.REASON + error);
              }

            })
            .finally(this.hideDimmer);
        };

        reader.onerror = (event) => {
          reader.abort();
          alert(Strings.SEND_FILE_FAILURE + Strings.REASON + event);
        };

        reader.readAsArrayBuffer(input.files[0]);
      }
    }
    else {
      alert(Strings.SELECT_FILE);
    }
  }

  handleNTPAddressChange = (e, { value }) => {
    this.setState({ ntpAddr: value });
  }

  toggleNtpActive = () => {
    this.setState({
      ntpCheckboxLabel: !this.state.isNtpActive ? "Ligado" : "Desligado",
      isNtpActive: !this.state.isNtpActive
    });
  }

  alterTags = () => {
    this.props.history.push({
      pathname: "/tags"
    });
  }

  getModals = () => {
    return (
      <React.Fragment>
        <Modal basic size='small' open={this.state.isNtpModalOpen}>
          <Header icon='power' content={Strings.TURN_NTP_SERVER_ON} />
          <Modal.Content>
            <p>{Strings.TURN_NTP_SERVER_ON_QUESTION_PROTOCOL}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideNtpModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleTurnNtpServerOnModalPositiveClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

      </React.Fragment>
    );
  }

  handleUpdateCycles = (updateType) => {
    this.showUpdateDimmer();
    let intervalID = -1;

    if (updateType === Constants.FILE_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
      intervalID = setInterval(this.handleUpdateStatus, 2000);
    }
    else if (updateType === Constants.NTP_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
      intervalID = setInterval(this.handleUpdateNtpStatus, 2000);
    }
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateStatus = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.UPDATE_FILES_FOUND) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.UPDATING_MONITOR_FILES_PROTOCOL);
          });
        }
        else if (this.state.updateStatus === Constants.UPDATE_FILES_FOUND && data.update === Constants.FINISHED_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.MONITOR_FILES_UPDATED_SUCCESSFULLY_PROTOCOL);
          });
        }
        else if (this.state.updateStatus === Constants.FINISHED_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.RESTARTING_MONITOR_WAIT_PROTOCOL);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.UPDATE_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.UPDATE_ERROR_STRING_PROTOCOL + error);
      });
  }

  handleUpdateNtpStatus = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, Strings.RESTARTING_MONITOR_WAIT_PROTOCOL);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.MONITOR_RESTART_SUCCESS_PROTOCOL);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.MONITOR_RESTART_FAILURE_PROTOCOL + error);
      });

  }

  handleTurnNtpServerOnModalPositiveClick = () => {
    this.hideNtpModal();
    this.updateNtpServer();
  }

  saveNtpServerInfo = () => {
    let isIpValid = UtilsInstance.validateIPAddress(this.state.ntpAddr);
    let isIPLoopback = UtilsInstance.isIPLoopback(this.state.ntpAddr);

    // Verify the network information provided. Only send it if it passes the validation
    if (!isIpValid || isIPLoopback || this.state.timezone.length === 0) {
      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      // If the IP is not valid or if it is the loopback IP (127.0.0.1)
      if (!isIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }
      else if (isIPLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP_NTP);
      }

      if (this.state.timezone.length === 0) {
        invalidInformationString = invalidInformationString.concat(Strings.SELECT_TIMEZONE);
      }

      alert(invalidInformationString);
    }
    else {
      // If the user is turning the ntp server off there is no need to ask
      // for permission to restart because the system will not restart
      if (this.state.isNtpActive === false) {
        this.updateNtpServer();
      }
      // If the user is turning the ntp server on we will need ask for permission
      // to restart the system
      else {
        this.showNtpModal();
      }
    }
  }

  updateNtpServer = () => {
    let data = JSON.stringify({
      ntp: this.state.isNtpActive,
      ntpIp: this.state.ntpAddr,
      timezone: this.state.timezone
    });

    if (this.state.isNtpActive === false) {
      this.showNtpDimmer();

      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_OFF_FAILURE + Strings.REASON + Strings.NTP_INFO_FAILURE);
          this.toggleNtpActive();
        })
        .finally(this.hideNtpDimmer);
    }
    else {
      this.showNtpDimmer();

      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          this.toggleNtpActive();
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_ON_FAILURE + Strings.REASON + Strings.NTP_INFO_FAILURE);
        })
        .finally(this.hideNtpDimmer);
    }
  }

  updateNtpServerFirstStep = () => {
    let intervalID = -1;
    this.showUpdateDimmer();
    this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INIT, "");
    intervalID = setInterval(this.handleUpdateNtpFirstStep, 2000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateNtpFirstStep = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "ntpUpdate", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.ntpUpdate);
        console.log("Data update Status: ", data.ntpUpdate);

        if (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED && data.ntpUpdate === Constants.NTP_UPDATE_START) {
          this.setState({ ntpUpdate: data.ntpUpdate }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INFO, "");
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_SUCCESS
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSED_NTP_INFO, "");
            clearInterval(this.state.intervalID);
            this.handleUpdateCycles(Constants.NTP_UPDATE_TYPE);
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_FAIL
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.PROCESSING_NTP_ERROR);
            this.toggleNtpActive();
          });
        }
      })
      .catch(() => {
        this.hideUpdateDimmer();
        clearInterval(this.state.intervalID);
        this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED });
        alert(Strings.PROCESSING_NTP_ERROR);
        this.toggleNtpActive();
      });
  }

  onTimezoneDropdownChange = (e, { value }) => this.setState({ timezone: value })

  changeLoginInfo = () => {
    this.props.onChangeRoute(
      "change-login",
      this.props.currProtConfigComponent,
      this.props.currAnDPConfigComponent
    );
  }

  configureTsExpert = () => {
    this.props.onChangeRoute(
      "ts-expert-config",
      this.props.currProtConfigComponent,
      this.props.currAnDPConfigComponent
    );
  }

  openEthernetPage = () => {
    this.props.onChangeRoute(
      "ethernet-config",
      this.props.currProtConfigComponent,
      this.props.currAnDPConfigComponent
    );
  }

  openWLANPage = () => {
    this.props.onChangeRoute(
      "wlan-config",
      this.props.currProtConfigComponent,
      this.props.currAnDPConfigComponent
    );
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    const isDimmerActive = this.state.isDimmerActive;
    const isNtpDimmerActive = this.state.isNtpDimmerActive;
    const isUpdateDimmerActive = this.state.isUpdateDimmerActive;

    return (
      <div>
        <Grid columns={2} doubling>
          <Grid.Column>

            <Segment style={updateSegmentStyle}>
              <Divider horizontal style={dividerStyle}>{Strings.SOFTWARE_UPDATE}</Divider>
              <p>{Strings.CURRENT_VERSION}<strong>{Constants.TS_MONITOR_VERSION}</strong></p>
              <Form style={formStyle} onSubmit={this.sendFile}>
                <Form.Input id="send-gpg-input" type="file" accept=".gpg"></Form.Input>
                <Button color="teal" type="submit" >{Strings.UPDATE}</Button>
              </Form>
              <Dimmer active={isDimmerActive} >
                <Loader>{Strings.SEND_FILE_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment textAlign="center" style={updateSegmentStyle}>
              <Divider horizontal style={dividerStyle}>{Strings.NTP_SERVER}</Divider>

              <Form onSubmit={this.saveNtpServerInfo}>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "1vh" }}>
                  <div style={{ flexGrow: 2 }}>
                    <Form.Field>
                      <label>{Strings.IP}</label>
                      <Input
                        fluid
                        placeholder="192.168.0.2"
                        value={this.state.ntpAddr}
                        onChange={this.handleNTPAddressChange} />
                    </Form.Field>

                    <Form.Field>
                      <label>{Strings.TIMEZONE}</label>
                      <Dropdown
                        fluid
                        placeholder={Strings.TIMEZONE}
                        search
                        selection
                        scrolling
                        options={Timezones.zones}
                        value={this.state.timezone}
                        onChange={this.onTimezoneDropdownChange} />
                    </Form.Field>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <Form.Field>
                      <Checkbox
                        toggle
                        onClick={this.toggleNtpActive}
                        checked={this.state.isNtpActive}
                        label={this.state.ntpCheckboxLabel} />
                    </Form.Field>
                  </div>
                </div>

                <Button color="teal" type="submit">{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={isNtpDimmerActive} >
                <Loader>{Strings.SEND_NTP_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

          </Grid.Column>

          <Grid.Column>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={dividerStyle}>
                    {Strings.ETHERNET}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        <p>{Strings.ETHERNET_POPUP_1}</p>
                        <p>{Strings.ETHERNET_POPUP_2_PROTOCOL}</p>
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openEthernetPage} />
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={dividerStyle}>
                    {Strings.WLAN}
                    <Popup position='top center' hoverable pinned wide="very"
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        <p>{Strings.WLAN_POPUP_1}</p>
                        <p>{Strings.WLAN_POPUP_2_PROTOCOL}</p>
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openWLANPage} />
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>
            <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={dividerStyle}>{Strings.TS_EXPERT}</Divider>
                  <Button
                    color="teal"
                    onClick={this.configureTsExpert}>
                    {Strings.SETUP}
                  </Button>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={dividerStyle}>{Strings.ALTER_LOGIN}</Divider>
                  <Button
                    color="teal"
                    onClick={this.changeLoginInfo}>
                    {Strings.ALTER}
                  </Button>
                </Segment>
              </Grid.Column>
            </Grid>

          </Grid.Column>
        </Grid >

        {this.getModals()}

        <Dimmer page active={isUpdateDimmerActive} >
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer >
      </div >
    );
  }
}

const mapActionsToProps = {
  onChangeRoute: changeRouteAction,
};

const mapStateToProps = state => ({
  currGenConfigComponent: state.configRoutes.currGenConfigComponent,
  currProtConfigComponent: state.configRoutes.currProtConfigComponent,
  currAnDPConfigComponent: state.configRoutes.currAnDPConfigComponent,
});

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const updateSegmentStyle = {
  textAlign: "center",
  paddingBottom: "8px"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const dividerStyle = {
  marginTop: "0",
  marginBottom: "8px",
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(GeneralConfiguration));
